export const createUrlSlug = (title: string): string => {
  return title
    .toLowerCase()
    .replace(/[&]/g, 'and')
    .replace(/[/]/g, '-')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
};